/**
 * @file 开发者社区 开源伙伴
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React, { useEffect, useRef } from 'react';
import { Button, Carousel } from 'antd';
import { IOpenSourcePartners } from './../../types';
import { LeftCircleOutlined, RightCircleOutlined, RightOutlined } from '@ant-design/icons';
import './style.less';

const DeveloperOpenPartner: React.FC<IOpenSourcePartners> = props => {
    const { title, subDesc, subDescPurpose, subBtn, subLink = '', list = [] } = props;
    // const [carousel, setCarousel]: any = useState([]);
    // 处理一下其他链接的锚点跳转,平滑滚动元素
    useEffect(() => {
        const anchorID = (new URLSearchParams(window.location.search.slice(1))).get('id');
        const anchorDom = document.querySelector(`#${anchorID}`);
        if (anchorID && anchorDom) {
            anchorDom.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            })
        }
    }, [title]);
    const sublist = list.slice(0, 15);
    const sublisttwo = list.slice(15, 30);
    const sublistthree = list.slice(30, 45);
    const card :any = useRef();
    
    return (
        <div className="developer-open-partner-wrapper">
            <div id="openSource"></div>
            <div className="open-partner-title">{title}</div>
            <div className="star-star-plan">
                <div className="star-plan-desc">{subDesc}</div>
                <div className="star-plan-destination">{subDescPurpose}</div>
                <Button type="primary" className="star-plan-entry" size="large" onClick={() => { window.location.href = subLink }}>{subBtn}</Button>
            </div>
            <div className="open-object">- 开源项目 -</div>
            <div className="open-partner-cards-wrapper">
                <div className="leftcirclr" onClick={() => {
                    card.current.prev();

                }}><LeftCircleOutlined /></div>
                <Carousel ref={card} >
                    <div className="link-active">
                        {
                            sublist.map(item =>
                                <div className="open-partner-card" key={item.title}>
                                    <img className="open-partner-icon" src={item.imageUrl} alt={item.title} />
                                    <a href={item.link}>
                                        <div className="open-partner-related-desc">
                                            <span>{item.desc}&nbsp;</span>
                                            <RightOutlined />
                                        </div>
                                    </a>
                                </div>
                            )
                        }
                    </div>
                    <div className="link-active"> 
                        {
                            sublisttwo.map(item =>
                                <div className="open-partner-card" key={item.title}>
                                    <img className="open-partner-icon" src={item.imageUrl} alt={item.title} />
                                    <a href={item.link}>
                                        <div className="open-partner-related-desc">
                                            <span>{item.desc}&nbsp;</span>
                                            <RightOutlined />
                                        </div>
                                    </a>
                                </div>
                            )
                        }
                    </div>
                    <div className="link-active">
                        {
                            sublistthree.map(item =>
                                <div className="open-partner-card" key={item.title}>
                                    <img className="open-partner-icon" src={item.imageUrl} alt={item.title} />
                                    <a href={item.link}>
                                        <div className="open-partner-related-desc">
                                            <span>{item.desc}&nbsp;</span>
                                            <RightOutlined />
                                        </div>
                                    </a>
                                </div>
                            )
                        }
                    </div>

                </Carousel>
                <div className="rightcirclr" onClick={() => {
                    card.current.next();
                }}><RightCircleOutlined /></div>
            </div>
        </div>

    );
};

export default DeveloperOpenPartner;